/* eslint-disable import/prefer-default-export */
import SDK from 'utils/sdk';
import { put, call, all, takeLatest } from 'redux-saga/effects';
import {
  REPORTS_RECEIVER,
  GLOBAL_REPORTS_RECEIVER,
} from 'utils/email-list-types';
import { toast } from 'react-toastify';
import { listEmails, updateEmails } from './actions';

export function* listEmailsSaga() {
  try {
    yield put(listEmails.request());
    const client = yield call([SDK, 'getClient']);
    const { data } = yield call([client, 'getEmailLists']);
    yield put(listEmails.success(data.data));
  } catch (error) {
    yield put(listEmails.failure(error));
  } finally {
    yield put(listEmails.fulfill());
  }
}

export function* updateEmailsSaga({ payload: { values } }) {
  try {
    const toSend = {
      list: [
        {
          type: REPORTS_RECEIVER,
          emails: values.keyMetrics.replace(' ', '').split(','),
        },
        {
          type: GLOBAL_REPORTS_RECEIVER,
          emails: values.consolidatedKeyMetrics.replace(' ', '').split(','),
        },
      ],
    };
    yield put(updateEmails.request());
    const client = yield call([SDK, 'getClient']);
    const { data } = yield call([client, 'updateEmailLists'], null, toSend);
    yield put(updateEmails.success(data.data));
    toast.success('Settings saved successfully');
  } catch (error) {
    yield put(updateEmails.failure(error));
    toast.error('There was an error when trying to save the settings');
  } finally {
    yield put(updateEmails.fulfill());
  }
}

export default function* emailsWatcher() {
  yield all([
    takeLatest(listEmails.trigger, listEmailsSaga),
    takeLatest(updateEmails.trigger, updateEmailsSaga),
  ]);
}
